export const mediaQueries = {
  "xl-min": "(min-width: 1640px)",
  "lg-only": "(min-width: 1200px) and (max-width: 1639px)",
  "lg-min": "(min-width: 1200px)",
  "lg-max": "(max-width: 1639px)",
  "md-only": "(min-width: 1024px) and (max-width: 1199px)",
  "md-min": "(min-width: 1024px)",
  "md-max": "(max-width: 1199px)",
  "sm-only": "(min-width: 768px) and (max-width: 1023px)",
  "sm-min": "(min-width: 768px)",
  "sm-max": "(max-width: 1023px)",
  "xs-only": "(min-width: 481px) and (max-width: 767px)",
  "xs-min": "(min-width: 481px)",
  "xs-max": "(max-width: 767px)",
  "xxs-max": "(max-width: 480px)",
  "animation-medium": "(max-width: 1280px)",
};
